<template>
  <b-modal :visible="value"
          @change="$emit('input', $event)"
          size="lg">
    <div slot="modal-header" minimize class="app-modal-header">
      <span class="app-modal-header__icon"><AppIcon :name="icon" /></span>
      <h5 class="app-modal-header__title">{{title}}</h5>
    </div>

    <div v-if="loading" class="text-center text-muted py-5">
      <b-spinner class="align-middle mr-2"></b-spinner> Cargando proyecto...
    </div>

    <div v-else>
      <b-row>
        <b-col md="6">
          <b-form-group label="Modo">
            <b-form-select v-model="form.mode" :options="arr.mode" @input="changeMode()"></b-form-select>
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group label="Estado">
            <b-form-select v-model="form.status" :options="arr.status"></b-form-select>
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group label="Nombre">
            <b-form-input type="text" size="sm" v-model="form.name" placeholder="Ingresar un nombre"> </b-form-input>
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group label="Descripción">
            <app-textarea
              v-model="form.description"
              size="sm"
              placeholder="Ingresar detalle sobre el alcance del proyecto"
            ></app-textarea>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <FindObject render="search"
                      type="customers"
                      @select-object="loadCustomer($event)"
                      :valueID="form.customer_id"
                      :where="conditionCustomersActive"/>
        </b-col>

        <b-col md="6" v-if="form.mode=='with_expiration'">
          <b-form-group label="Horas Estimadas" description="Horas total de estimación para el proyecto">
            <b-form-input type="number" size="sm" v-model="form.hours_estimated" placeholder="Horas Estimadas"> </b-form-input>
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group label="Fecha de Inicio">
            <b-form-datepicker size="sm" v-model="form.date_init" placeholder="Fecha de Inicio" local="es"></b-form-datepicker>
          </b-form-group>
        </b-col>

        <b-col md="6" v-if="form.mode=='with_expiration'">
          <b-form-group label="Fecha de Finalización">
            <b-form-datepicker size="sm" v-model="form.date_end" placeholder="Fecha de Finalización" local="es"></b-form-datepicker>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row v-if="moduleSalesActive && form.mode=='without_expiration'">
        <b-col md="6">
          <FindObject render="search"
                      type="services"
                      @select-object="loadServices($event)"
                      :valueID="form.services_invoice_id"
                      tag="Servicio vinculado para facturar" />
        </b-col>
        <b-col md="6">
          <b-form-group label="Horas Incluidas Por Mes">
            <b-form-input type="number"
                          size="sm"
                          v-model="form.monthly_hours_included"
                          step='0.01'
                          placeholder="Ingresar cantidad de horas">
            </b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group label="Observaciones">
            <app-textarea
              v-model="form.observations"
              size="sm"
              placeholder="Ingresa las observaciones"
            ></app-textarea>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <FindObject type="employee"
                      @select-object="loadEmployee($event)"
                      :valueID="form.employee_id"
                      tag="Project Manager"
                      :where="conditionEmployeActive" />
        </b-col>

        <b-col md="6">
          <b-form-group label="Equipo" description="Seleccione todos los empleados que van a poder visualizar el proyecto">
            <b-form-select v-model="form.equipo" :options="arr.employee" multiple :select-size="4"></b-form-select>
            <b-button type="button" variant="outline-dark" size="sm" class="btn-pill mt-1" @click="form.equipo=[]">
              <AppIcon name="refresh" />
              Borrar Selección
            </b-button>
          </b-form-group>
        </b-col>
      </b-row>
    </div>

    <div slot="modal-footer">
      <b-button variant="outline-secondary" class="mr-1" :disabled="saving" @click="cancel()">Cancelar</b-button>
      <b-button variant="dark" :disabled="loading || saving" @click="save()"><AppIcon name="save" class="mr-1" />Guardar</b-button>
    </div>
  </b-modal>
</template>
<script>
  import serviceAPI from '../services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'
  import Modules from '@/config/modules'
  import FindObject from '@/components/inc/find/findObject'

  // Formulario independiente del JSON de la tabla: al editar, este
  // componente pide sus propios datos frescos a la API (mostrarProyectos)
  // en vez de recibir el item ya cargado en el listado. Vive en su propio
  // componente (no inline en crudProject.vue) para que Vue le asigne su
  // propio render watcher — tipear acá ya no fuerza el recálculo de las
  // tablas grandes del listado (avatares, fechas, badges de equipo).
  const emptyForm = () => ({
    id: 0,
    mode: 'with_expiration',
    name: '',
    customer_id: 0,
    customer: null,
    date_init: '',
    date_end: '',
    hours_estimated: 0,
    employee_id: 0,
    employee: null,
    equipo: [],
    description: '',
    status: 'active',
    services_invoice_id: 0,
    services_invoice: null,
    monthly_hours_included: 0,
    observations: '',
  })

  export default {
    components: {
      FindObject
    },
    props: {
      value: { type: Boolean, default: false },
      // 0/falsy => alta. Con id > 0 el componente busca el proyecto por su
      // cuenta (no confía en lo que ya esté cargado en la tabla del listado).
      projectId: { type: [Number, String], default: 0 },
    },
    data() {
      return {
        loading: false,
        saving: false,
        form: emptyForm(),
        arr: {
          mode: [
            {value:'with_expiration', text: 'Con Vencimiento'},
            {value:'without_expiration', text: 'Sin Vencimiento'},
          ],
          status: [
            {value:'active', text: 'Activo'},
            {value:'pause', text: 'Pausado'},
            {value:'finished', text: 'Finalizado'},
            {value:'canceled', text: 'Cancelado'},
          ],
          employee: [],
        },
      }
    },
    computed: {
      isEdit() {
        return !!this.projectId
      },
      title() {
        return this.isEdit ? 'Editar Proyecto' : 'Nuevo Proyecto'
      },
      icon() {
        return this.isEdit ? 'edit' : 'add'
      },
      conditionCustomersActive(){
        return [{field: 'active', condition: true}];
      },
      conditionEmployeActive(){
        return [{field: 'active', condition: true}];
      },
      moduleSalesActive() {
        var status = false
        var modules = Session.getSession().auth.user.permissions.modules
        modules.forEach(element => {
          if(element.id == Modules.VENTAS) {
            status = true
          }
        })
        return status
      },
    },
    // El padre fuerza un remount de este componente en cada apertura
    // (:key="modal.form._id" cambia en add()/edit()), así que `value`
    // nace ya en `true` — un watch sobre esa prop nunca ve el cambio
    // false→true y `loadForEdit()` no llegaba a dispararse. Con el
    // remount ya garantizado, alcanza con resolver el estado inicial acá.
    created() {
      if(this.isEdit) {
        this.loadForEdit()
      }
    },
    methods: {
      loadForEdit() {
        this.loading = true
        var result = serviceAPI.mostrarProyectos(this.projectId)

        result.then((response) => {
          var item = response.data

          this.form.id = item.id
          this.form.mode = item.mode
          this.form.name = item.name
          this.form.customer_id = item.customer.id
          this.form.customer = item.customer
          this.form.date_init = item.date_init
          this.form.date_end = item.date_end
          this.form.hours_estimated = item.hours_estimated

          // El endpoint de "mostrar" (a diferencia del de filtro/listado)
          // no trae la relación `employee` cargada — solo el id plano.
          // `employee_id` alcanza: el propio FindObject resuelve y muestra
          // el objeto completo a partir del id (ver su `mounted()`/`selected()`),
          // y emite `select-object` reponiendo `form.employee` (ver loadEmployee()).
          this.form.employee = item.employee || null
          this.form.employee_id = item.employee_id || 0

          if(item.equipo) {
            this.form.equipo = item.equipo.split(',')
          } else {
            this.form.equipo = []
          }

          this.form.description = item.description
          this.form.status = item.status
          this.form.services_invoice = item.services_invoice
          this.form.services_invoice_id = item.services_invoice_id
          this.form.monthly_hours_included = item.monthly_hours_included
          this.form.observations = item.observations

          this.loadArrEmployee()
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
          this.$emit('input', false)
        })
        .finally(() => {
          this.loading = false
        })
      },
      changeMode(){
        if(this.form.mode == 'without_expiration') {
          this.form.date_end = ''
          this.form.hours_estimated = 0
        }
      },
      loadCustomer (object) {
        if(object){
          this.form.customer = object
          this.form.customer_id = object.id
        } else {
          this.form.customer = null
          this.form.customer_id = 0
        }
      },
      loadEmployee (object) {
        if(object){
          this.form.employee = object
          this.form.employee_id = object.id
        } else {
          this.form.employee = null
          this.form.employee_id = 0
        }

        this.loadArrEmployee()
      },
      loadServices(object) {
        if(object){
          this.form.services_invoice = object
          this.form.services_invoice_id = object.id
        } else {
          this.form.services_invoice = null
          this.form.services_invoice_id = 0
        }
      },
      loadArrEmployee() {
        var result = serviceAPI.obtenerEmpleado()
        result.then((response) => {
          var data = response.data

          this.arr.employee = []
          data.forEach(element => {
            if(!element.active) return
            if(this.form.employee_id && element.id == this.form.employee_id) return
            this.arr.employee.push({ value: element.id, text: element.name })
          });
        })
      },
      cancel() {
        this.$emit('input', false)
      },
      save() {
        this.saving = true
        let loader = this.$loading.show();
        var result = this.isEdit ? serviceAPI.editarProyectos(this.form) : serviceAPI.agregarProyectos(this.form);

        result.then((response) => {
          loader.hide()
          this.saving = false
          this.$awn.success("Datos guardados con éxito");
          this.$emit('saved', response.data)
          this.$emit('input', false)
        })
        .catch(error => {
          loader.hide()
          this.saving = false
          this.$awn.alert(Error.showError(error));
        })
      },
    },
  }
</script>
